import { render, staticRenderFns } from "./customerQuotationCreate.vue?vue&type=template&id=3838fb50&scoped=true"
import script from "./customerQuotationCreate.vue?vue&type=script&lang=js"
export * from "./customerQuotationCreate.vue?vue&type=script&lang=js"
import style0 from "./customerQuotationCreate.vue?vue&type=style&index=0&id=3838fb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838fb50",
  null
  
)

export default component.exports